import { render, staticRenderFns } from "./ContractValidityHistory.vue?vue&type=template&id=2a325916"
import script from "./ContractValidityHistory.vue?vue&type=script&lang=js"
export * from "./ContractValidityHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports